<div class="text-search-input_search-icon">
  <svg><use xlink:href="#search"></use></svg>
</div>
<input
  type="text"
  class="text-search-input_text-input"
  [placeholder]="searchFilter.placeholder | l10n"
  [(ngModel)]="searchFilter.query"
  (ngModelChange)="updateFilter.next($event)"/>
@if (searchFilter.query) {
  <div class="text-search-input_clear-btn"
    (click)="clearSearchFormControl()">
    <svg><use xlink:href="#small-close"></use></svg>
  </div>
}
